import * as React from "react";
import { Link } from "react-router-dom";
import TextLogo from "../TextLogo/index";
import styles from "./styles.scss";

const Header = (props: React.PropsWithChildren<unknown>) => {
  return (
    <header className={styles.header}>
      <div className={styles.logo}>
        <Link to={"/"}>
          <TextLogo />
        </Link>
      </div>
      {props.children}
    </header>
  );
};

export default Header;
